import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Label from 'components/Label';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import RadioButton from '../BaseFields/Radio';

type RadioConditionGroupProps = {
  label: string | ReactElement;
  name: string;
  suffix?: ReactElement;
  value: boolean | string;
};
const RadioConditionGroup: React.VFC<RadioConditionGroupProps> = ({
  label,
  suffix,
  value,
  ...rest
}) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={1.25} alignItems="center">
      <Grid item xs={12} md={8}>
        <Label className="mb-0">{label}</Label>
      </Grid>
      <Grid item xs={12} md={4}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: '#68686A',
          }}
        >
          <RadioButton {...rest} label={t('yes')} value="TRUE" checked={value === 'TRUE'} />
          <Box
            sx={{
              ml: '5px',
            }}
          >
            <RadioButton {...rest} label={t('no')} value="FALSE" checked={value === 'FALSE'} />
          </Box>
          {suffix}
        </Box>
      </Grid>
    </Grid>
  );
};
export default RadioConditionGroup;
